import React from "react"
import axios from "axios"

import Chatbot from "./components/Chatbot"

// import minimal configuration information from the hosting html context
const config = {
  uid: window.uid,
  server: window.server,
	jwt: window.jwt,
}

/*
	Das JWT sollte jetzt entweder über die einbindende Datei gesetzt werden oder in local.config.js über die folgende Zeile:
	window.jwt = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjE5OSwiaWF0IjoxNTgxODM2NDM3fQ.x6shMJaLVhvjUSyBO4B-g1bG2ZJ4T7Hl3pSK1C_9Ee4';
*/

if ((typeof config.jwt === 'undefined') || (!config.jwt)) console.error('Missing JWT. Please make sure it is provided by the hosting environment via the calling html page or a local.config.js file')


class App extends React.Component{
  state = {
    jsonwebtoken: config.jwt,
    chatBotIsActive: false,
    nofUnread: 0,
    data: null,
    activeChannelId: null,
    loadedChannelId: null,
    pollKey: null,
    lockHttpRequest: false,
    timeHandler: []
  }

  componentDidMount() {
    // trigger poll intervall
    this.triggerPoll()
  }

  componentWillUnmount() {
    clearInterval(this.pollInterval)
  }


  triggerPoll() {
    const pollKey = Date.now()
    this.setState({pollKey: pollKey}, () => {
      this.poll(pollKey)
    })
  }

  poll = key => {
      // start poll
      this.pollingCode()

      // execute only latest poll
      if(key === this.state.pollKey) {
        const pollKey = Date.now()
        this.setState({pollKey: pollKey})
        this.pollInterval = setTimeout(this.poll.bind(null, pollKey), 3000)
      }
  }

  pollingCode() {
    if(!this.state.lockHttpRequest) {
      axios.get("http://"+config.server.host+":"+config.server.port+"/?op=nofUnread&chatBotIsActive="+(this.state.chatBotIsActive ? 1 : 0), {
        headers: { Authorization: `Bearer ${this.state.jsonwebtoken}` }
      })
      .then(res => {
        if(res.data && this.state.nofUnread !== res.data.nofUnread) {
          this.setState({nofUnread: res.data.nofUnread})
        }
        // trigger actions depending on the status of the chatbot
        if(res.data && res.data.nofUnread > 0) {
          if(this.state.chatBotIsActive) {
            if(this.state.activeChannelId) {
              this.initChannel(this.state.activeChannelId)
            } else {
              this.initAll()
            }
          }
        }
      })
      .catch(err => {
        console.log("nofUnread "+err.toString())
      })
    }
  }

  setActiveChannelId = activeChannelId => {
    this.setState({activeChannelId: activeChannelId})
  }

  toggleChatbot = () => {
    if(!this.state.chatBotIsActive) {
      this.initAll()
    } else {
      this.setState({activeChannelId:null, loadedChannelId: null})
    }
    this.setState({chatBotIsActive: !this.state.chatBotIsActive})
  }

  initAll() {
    axios.get("http://"+config.server.host+":"+config.server.port+"/?op=initAll", {
      headers: { Authorization: `Bearer ${this.state.jsonwebtoken}` }
    })
    .then(res => {
      let sortedData = this.sortChannelsByTimestamp(res.data.channels)
      if(JSON.stringify(this.state.data) !== JSON.stringify(sortedData)) {
        this.setState({data: sortedData})
      }
    })
    .catch(err => {
      console.log("initAll "+err.toString())
    })
  }

  initChannel = id => {
    axios.get("http://"+config.server.host+":"+config.server.port+"/?op=initChannel&id="+id, {
      headers: { Authorization: `Bearer ${this.state.jsonwebtoken}` }
    })
    .then(res => {
      let sortedData = this.sortChannelsByTimestamp(res.data.channels)
      if(JSON.stringify(this.state.data) !== JSON.stringify(sortedData)) {
        // waiting for channel data then set trigger to show chat
        this.setState({data: sortedData}, () => {
          if(this.state.loadedChannelId !== id) {
            this.setState({loadedChannelId: id})
          }
        })
      }
    })
    .catch(err => {
      console.log("initChannel "+err.toString())
    })
  }


  selectOption = (channelIndex, channelId, messageId, option, showEditButton) => {
    // stop request from backend to avoid confusion with data state
    this.setState({lockHttpRequest: true})

    // deep data copy
    let dataCopy = JSON.parse(JSON.stringify(this.state.data))
    // update channelIndex for deep data copy if sorting hast changed order of channels
    dataCopy.forEach((channel, index) => {
      if(channel.id === channelId) {
        channelIndex = index
      }
    })

    // if dialog already finished, update channel status
    let farewell = dataCopy[channelIndex].farewell
    if(farewell) {
      dataCopy[channelIndex].farewell = false
      this.setState({data: this.sortChannelsByTimestamp(dataCopy)})
    }

    // remove messages until selection
    let mLength = dataCopy[channelIndex].messages.length
    for (let i = mLength-1; i >= 0; i--) {
      let m = dataCopy[channelIndex].messages[i]
      if(m && m.id === messageId) {
        break
      }
      dataCopy[channelIndex].messages.pop()
    }

    // add message with selected answer
    this.triggerMessage(dataCopy, channelIndex, 200, "text", true, option.text, "answer", 0)
    // add message with loading spin
    this.triggerMessage(dataCopy, channelIndex, 1300, "text", false, " ", "loading", 0)


    // transmit selection to backend
    axios.get("http://"+config.server.host+":"+config.server.port+"/?op=selectOption&messageId="+messageId+"&optionId="+option.id+"&optionText="+option.text, {
      headers: { Authorization: `Bearer ${this.state.jsonwebtoken}` }
    })
    .then(res => {
      let timeout = setTimeout(() => {
        this.setState({lockHttpRequest: false}, () => {
          this.triggerPoll()
          showEditButton()
        })
      }, 1500)
      this.addTimeout(timeout)
    })
    .catch(err => {
      console.log("selectOption "+err.toString())
    })
  }

  triggerMessage(dataCopy, channelIndex, delay, type, byUser, text, id, age) {
    let message = {
      type: type,
      byUser: byUser,
      text: text,
      id: id,
      age: age,
      timestamp: Date.now()
    }

    if(Array.isArray(dataCopy) && Number.isInteger(channelIndex) && dataCopy.length > channelIndex && Number.isInteger(delay)) {
      let timeout = setTimeout(() => {
        dataCopy[channelIndex].messages.push(message)
        this.setState({data: this.sortChannelsByTimestamp(dataCopy)})
      }, delay)
      this.addTimeout(timeout)
    }
  }

  addTimeout(timeout) {
    // add timeout to list of upcoming events to stop it when changing channels
    this.setState(previousState => ({
      timeHandler: [...previousState.timeHandler, timeout]
    }))
  }

  // is triggered if channel changes
  unmountChat = () => {
    let timeHandler = this.state.timeHandler
    if(timeHandler.length) {
      for(let timeout of timeHandler) {
        clearTimeout(timeout)
      }
      this.setState({timeHandler: []})
    }
    // if blocked, make polling possible
    if(this.state.lockHttpRequest) {
      this.setState({lockHttpRequest: false})
    }
  }

  repeatDialog = (channelId, resetTriggerButton) => {
    axios.get("http://"+config.server.host+":"+config.server.port+"/?op=repeatDialog&channelId="+channelId, {
      headers: { Authorization: `Bearer ${this.state.jsonwebtoken}` }
    })
    .then(res => {
      this.setState({activeChannelId: null})
      this.setState({loadedChannelId: null}, () => {
        this.triggerPoll()
      })
    })
    .catch(() => {
      resetTriggerButton()
    })
  }

  sortChannelsByTimestamp(data) {
    let sortedData = JSON.parse(JSON.stringify(data))
    if(sortedData) {
      sortedData.sort((a, b) => {
        let lastA = a.messages[a.messages.length-1]
        let lastB = b.messages[b.messages.length-1]
        if(lastA && lastB && lastA.timestamp && lastB.timestamp) {
          let timeA = lastA.timestamp
          let timeB = lastB.timestamp
          if(timeA < timeB) return 1
          else if(timeA > timeB) return -1
          else return 0
        }
        return 0
      })
    }
    return sortedData
  }


  render() {
    return (
      <div className="App">
        {this.state.chatBotIsActive ?
          <Chatbot data={this.state.data} activeChannelId={this.state.activeChannelId} loadedChannelId={this.state.loadedChannelId} setActiveChannelId={this.setActiveChannelId} toggleChatbot={this.toggleChatbot} initChannel={this.initChannel} selectOption={this.selectOption} repeatDialog={this.repeatDialog} unmountChat={this.unmountChat}/> :
          <ChatbotButton toggleChatbot={this.toggleChatbot} nofUnread={this.state.nofUnread}/>
        }
      </div>
    )
  }
}

function ChatbotButton (props) {
  return (
    <button
			onClick={props.toggleChatbot}
			title={parseInt(props.nofUnread) + ' unread channels'}
			className={ (props.nofUnread > 0) ? 'active' : 'idle' }
		>
			<span className="button-text">Enter Chatbot</span> <span className="button-counter">{props.nofUnread}</span>
		</button>
  )
}

export default App;
